const assetBase = "https://web.wlyk.com/static/yufei_guonei/";

const company = {
  name: "深圳市宇飞智能科技有限公司",
  shortName: "宇飞智能",
  slogan: "云端智慧通行全场景解决方案",
  description:
    "宇飞智能专注智慧停车、车牌识别、人行通道、门禁门控与城市级通行管理平台建设，以云计算和物联网能力帮助园区、商业综合体、交通枢纽与城市运营方提升管理效率。",
  email: "info@iyufei.com",
  phone: "400-6083520",
  address: "深圳市龙华区观澜街道牛湖社区高尔夫大道89号G栋201",
  icp: "粤ICP备2021084149号"
};

const stats = [
  { value: "2015", label: "公司成立", suffix: "年" },
  { value: "15+", label: "行业经验", suffix: "年" },
  { value: "10000+", label: "服务停车场", suffix: "个" },
  { value: "32+", label: "覆盖国家和地区", suffix: "个" },
  { value: "10+", label: "专利与软件著作权", suffix: "项" }
];

const solutions = [
  {
    title: "无人值守停车场",
    desc: "车牌识别、无感支付、远程协助、异常工单闭环，让停车场从人力值守升级为云端运营。",
    tag: "Parking Cloud"
  },
  {
    title: "城市级智慧停车",
    desc: "支持多停车场集中管理、数据看板、运营分析和多角色权限，适合集团化与城市级平台建设。",
    tag: "City Platform"
  },
  {
    title: "人车通行一体化",
    desc: "融合车行、人行、门禁、访客与车位引导，形成园区、社区、商业综合体的统一通行入口。",
    tag: "Access Control"
  }
];

const productHighlights = [
  "车牌识别一体机",
  "道闸与出入口控制",
  "车位引导系统",
  "人脸识别终端",
  "升降柱与安防路障",
  "云平台运营系统"
];

const cases = [
  {
    id: 1,
    title: "汕尾保利希尔顿逸林酒店",
    CreateTime: "2023-08-10",
    Img: `${assetBase}图片32.png`,
    content:
      "项目位于金町湾滨海度假区，通过智慧停车与通行管理系统提升酒店车辆进出效率，为住客和访客提供更顺畅的到达体验。"
  },
  {
    id: 2,
    title: "深圳湾口岸",
    CreateTime: "2022-07-05",
    Img: `${assetBase}图片33.jpg`,
    content:
      "面向高频跨境通行场景，系统帮助口岸区域完成车行秩序管理、数据采集和异常事件响应，提升现场运营效率。"
  },
  {
    id: 3,
    title: "深圳航空基地",
    CreateTime: "2023-06-08",
    Img: `${assetBase}图片35.jpg`,
    content:
      "围绕航空基地复杂的车辆进出与内部管理需求，部署稳定可靠的识别设备和云端管理能力，保障高强度通行场景。"
  },
  {
    id: 4,
    title: "深圳市田面股份有限公司",
    CreateTime: "2023-05-10",
    Img: `${assetBase}图片36.jpg`,
    content:
      "以集中化管理方式整合社区与物业通行资源，减少现场管理压力，让停车收费、权限管理和数据统计更清晰。"
  },
  {
    id: 5,
    title: "大中华国际交易广场",
    CreateTime: "2023-04-02",
    Img: `${assetBase}图片37.jpg`,
    content:
      "服务大型商业办公综合体，用智能识别、快速通行和云端运营能力承接高峰期车流，提升商业空间的服务品质。"
  },
  {
    id: 6,
    title: "深圳宝安定岗湖湿地公园",
    CreateTime: "2023-08-02",
    Img: `${assetBase}图片40.jpg`,
    content:
      "面向公园公共服务场景，系统兼顾访客体验与管理效率，为城市公共空间提供更轻量、更稳定的停车管理能力。"
  }
];

const news = [
  {
    id: 1,
    title: "中国智能交通建设推荐品牌",
    CreateTime: "2023-10-25",
    Img: `${assetBase}tu41.JPG`,
    content:
      "宇飞智能获得中国智能交通建设推荐品牌相关荣誉，体现了行业对公司智慧停车与智能通行解决方案的认可。"
  },
  {
    id: 2,
    title: "中国智慧停车优秀企业",
    CreateTime: "2023-10-25",
    Img: `${assetBase}tu43.JPG`,
    content:
      "凭借稳定的产品能力和项目交付经验，宇飞智能入选智慧停车领域优秀企业，持续服务多类型停车运营场景。"
  },
  {
    id: 3,
    title: "智慧停车技术创新方案奖",
    CreateTime: "2023-10-25",
    Img: `${assetBase}tu45.JPG`,
    content:
      "车牌识别云计算 AI 无人值守方案获得技术创新类认可，进一步验证了云端化、平台化路线的应用价值。"
  },
  {
    id: 4,
    title: "安博会现场展示智能通行方案",
    CreateTime: "2023-10-26",
    Img: `${assetBase}tu48.JPG`,
    content:
      "宇飞智能在展会现场展示智慧停车、人车通行与云端管理能力，与合作伙伴共同探索更多行业应用场景。"
  }
];

const honors = [
  { Img: `${assetBase}图片19.png`, Remark: "公安部检测报告" },
  { Img: `${assetBase}图片20.png`, Remark: "公安部检测报告" },
  { Img: `${assetBase}图片22.png`, Remark: "注册商标" },
  { Img: `${assetBase}图片23.png`, Remark: "无人值守软件著作权" },
  { Img: `${assetBase}图片24.png`, Remark: "视频对讲软件著作权" },
  { Img: `${assetBase}图片26.png`, Remark: "云计算平台软件著作权" },
  { Img: `${assetBase}tu500.png`, Remark: "智慧停车优秀企业" },
  { Img: `${assetBase}tu501.png`, Remark: "智慧停车技术创新方案奖" }
];

const timeline = [
  { year: "2015", title: "公司成立", desc: "宇飞智能正式成立，聚焦智慧停车与出入口管理。" },
  { year: "2016", title: "研发团队扩充", desc: "持续投入云端管理平台和前端设备能力建设。" },
  { year: "2017", title: "生产与交付体系完善", desc: "形成研发、生产、销售、服务一体化交付能力。" },
  { year: "2023", title: "行业荣誉升级", desc: "获得智慧停车与智能交通领域多项行业认可。" }
];

const teams = [
  `${assetBase}tu503.jpg`,
  `${assetBase}tu504.jpg`,
  `${assetBase}tu505.jpg`,
  `${assetBase}tu506.jpg`,
  `${assetBase}tu507.jpg`,
  `${assetBase}tu508.jpg`
];

export default {
  company,
  stats,
  solutions,
  productHighlights,
  cases,
  news,
  honors,
  timeline,
  teams
};
